import {pushNotification} from '@malt/joy-v2/src/js/notification';

Hop.defineModule('connected-account-email-validation-check', (el, {accountId}) => {
    if (!accountId) {
        throw new Error('"accountId" parameter should be present');
    }
    const resendLink = el.querySelector('#resendAddressValidationEmail > a');
    const VALIDATION_PATH = '/api/email-verification-progress';

    function registerResendLinkListener() {
        if (resendLink) {
            let debouncedSendValidationEmail = false;
            let sendValidationEmail = () => {
                Hop.post(`${VALIDATION_PATH}/${accountId}/validation-email-sending`, {
                    'Content-Type': 'application/json',
                }).then(() => {
                    const msg = Hop.message('company.invitation.link.signup.email.validation.modal.try.again.feedback');
                    pushNotification(msg, {level: 'success'});
                });

                // even tough the server will prevent too much sending, there's no point in letting the
                // user click furiously on that link
                if (!debouncedSendValidationEmail) {
                    sendValidationEmail = Hop.debounce(sendValidationEmail, 5 * 1000);
                    debouncedSendValidationEmail = true;
                }
            };

            const listener = (e) => {
                e.preventDefault();
                sendValidationEmail();
            };

            resendLink.addEventListener('click', listener);

            return listener;
        }
    }

    const resendLinkListener = registerResendLinkListener();

    return function destroy() {
        if (resendLinkListener) {
            resendLink.removeEventListener('click', resendLinkListener);
        }
    };
});
